<template>
  <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content" ref="content">
      <div class="skt" ref="skt">
        <div class="select">
          <span class="xzqh">山塘名称:</span>
          <div class="selcountry">
            <el-input v-model="query.searchName" clearable placeholder="请输入" @change="Global.emptyQuery(query.searchName,thedata)"></el-input>
          </div>
          <span id="search" @click="searchTheData">查询</span>
          <span v-if="allowsPerm.delete" id="del" @click="delDialog"><span class="del-icon"></span>删除</span>
          <span v-if="allowsPerm.update" id="edit" @click="editDialog"><span class="edit-icon"></span>编辑</span>
          <span v-if="allowsPerm.insert" id="add" @click="addDialog"><span class="add-icon"></span>新增</span>
        </div>
        <div class="tablebox">
          <div class="fzxxtable">
            <el-table ref="multipleTable" @row-click="clickRow"  v-loading="loading" :data="tdata" :max-height="height" border @selection-change="handleSelectionChange" style="width: 100%; text-align: center;">
              <el-table-column  type="selection" width="40" align="center">
              </el-table-column>
              <el-table-column  type="index" width="60" label="序号" align="center" header-align="center">
              </el-table-column>
              <el-table-column  prop="reservoirName" label="山塘名称" >
              </el-table-column>
               <el-table-column  prop="adcdnm" label="地区" >
              </el-table-column>
                <!-- 列表默认不显示经纬度坐标 -->
               <el-table-column prop="lng"  label="经度" min-width="150" v-if= "false">
              </el-table-column>
              <el-table-column prop="lat"  label="纬度" min-width="150" v-if= "false">
              </el-table-column>
              <el-table-column  prop="address" label="详细地址" >
              </el-table-column>
                <el-table-column align="right" prop="storage" label="总库容(万m³)" :render-header="renderheader" >
              </el-table-column>
                 <el-table-column align="right" prop="rainfallArea" label="集雨面积(k㎡)" :render-header="renderheader" >
              </el-table-column>
               <el-table-column align="right" prop="damLength" label="主坝坝长(m)" :render-header="renderheader" >
              </el-table-column>
              <el-table-column align="right" prop="damHeight" label="主坝坝高(m)" :render-header="renderheader">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <pager
            @current-change="onCurrentChange"
            @size-change="onSizeChange"
            :pageIndex="pageIndex"
            :pageSize="pageSize"
            :total="total"
        ></pager>
      </div>
    </div>
    <el-dialog
      class="abow_dialog"
      :title="status + '山塘信息'"
      :close-on-click-modal="false"
      :visible.sync="addbtn">
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="160px" label-height="40px">
        <el-form-item label="山塘名称:" prop="reservoirName">
          <el-input v-model="form.reservoirName"></el-input>
        </el-form-item>
        <el-form-item label="乡镇:" prop="adcdid">
          <el-select v-model="form.adcdid" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in mutiRanksAdcd"
              :key="'f'+item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="经度:" prop="lng">
          <el-input v-model="form.lng"></el-input>
        </el-form-item>
        <el-form-item label="纬度:" prop="lat">
          <el-input v-model="form.lat"></el-input>
           <DrawPoint :globalmapId='globalmapId' :latlng='latlngarr' @changeAdd='handleChangeAdd'></DrawPoint>
        </el-form-item>
         <el-form-item label="详细地址:" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
         <el-form-item label="总库容(万立方米):" prop="storage">
          <el-input v-model="form.storage"></el-input>
        </el-form-item>
        <el-form-item label="集雨面积(km²):" prop="rainfallArea">
            <el-input v-model="form.rainfallArea"></el-input>
        </el-form-item>
          <el-form-item label="坝长(m):" prop="damLength">
          <el-input v-model="form.damLength"></el-input>
        </el-form-item>
        <el-form-item label="坝高(m):" prop="damHeight">
          <el-input v-model="form.damHeight"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import baseTypes from '@/store/types/base'
import Pager from '@/components/Pager'
import DrawPoint from '@/components/DrawPoint'
export default {
  props: ['addvcd'],
  components: {
    Pager, DrawPoint
  },
  data () {
    return {
      query: {
        adcdA: []
      },
      loading: false,
      height: 10,
      form: {},
      rules: {
        reservoirName: [
          { required: true, message: '山塘名称不能为空' }
        ],
        adcdid: [
          { required: true, message: '请选择乡镇' }
        ],
        cacd: [
          { required: true, message: '请选择所属小流域' }
        ],
        reservoirScale: [
          { required: true, message: '请选择工程类别' }
        ],
        rType: [
          { required: true, message: '请选择水库类型' }
        ],
        damHeight: [
          { required: true, message: '坝高不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        damLength: [
          { required: true, message: '坝长不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        storage: [
          { required: true, message: '总库容不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        address: [
          { required: true, message: '详细地址不能为空' }
        ],
        waterArea: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        rainfallArea: [
          { required: true, message: '集雨面积不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        lng: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ],
        lat: [
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ]
      },
      addbtn: false,
      pageIndex: 1,
      pageSize: 20,
      cPageIndex: '1',
      total: 0,
      cPageSize: '100',
      tdata: [],
      multipleSelection: [],
      status: '新增',
      aDCD: '330324',
      mutiRanksAdcd: [],
      all: true,
      cacds: [],
      rTypes: [],
      barrageTypes: [],
      releaseTypes: [],
      reservoirScales: [],
      globalmapId: 'baseInfo',
      latlngarr: [],
      lat: 28.273886, // 新增初始经纬度坐标
      lng: 120.690968
    }
  },
  watch: {
    addvcd (val, oldVal) { // 普通的watch监听
      this.loading = true
      this.pageIndex = 1 // 查询重置页码
      this.query.adcd = val
      this.thedata()
    }
  },
  methods: {
    handleChangeAdd (data) {
      // this.form.lng = data.lng
      // this.form.lat = data.lat
      this.form.lng = this.$set(this.form, 'lng', data.lng)
      this.form.lat = this.$set(this.form, 'lat', data.lat)
    },
    onSizeChange (pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.thedata()
    },
    onCurrentChange (pageIndex) {
      this.pageIndex = pageIndex
      this.thedata()
    },
    searchTheData () {
      this.pageIndex = 1 // 重置页码
      this.thedata()
    },
    // 表头换行
    renderheader (h, { column, $index }) {
      return h('span', {}, [
        h('span', {}, column.label.split('@')[0]),
        h('br'),
        h('span', {}, column.label.split('@')[1])
      ])
    },
    getReservoirScaleName: function (row) {
      let reservoirScale = row.reservoirScale
      let option = this.reservoirScales.find(item => {
        return item.name === reservoirScale
      })
      let returnData = ''
      if (option !== undefined) {
        returnData = option.remark
      }
      return returnData
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    thedata () {
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_RESERVOIR, { cacd: this.query.cacd, reservoirScale: 'Ⅵ', adcd: this.query.adcd, searchName: this.query.searchName, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
        this.tdata = data.results
        this.total = data.total
        this.loading = false
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.latlngarr = [] // 重置经纬度
      this.form = {}
      // this.form = Object.assign({}, { lat: this.lat, lng: this.lng })
      // this.latlngarr.push(this.lng, this.lat)
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog () {
      if (this.multipleSelection.length === 1) {
        this.latlngarr = [] // 重置经纬度
        this.status = '编辑'
        this.form = Object.assign({}, this.multipleSelection[0])
        this.addbtn = true
        this.latlngarr.push(this.form.lng, this.form.lat)
        this.Global.clearValidate(this, 'groupForm')
      } else {
        this.$alert('必需只选择一条信息', '提示')
      }
    },
    // 删除
    delDialog () {
      if (this.multipleSelection.length < 1) {
        this.$alert('必需选择一条信息', '提示')
      } else {
        let ids = []
        this.multipleSelection.forEach(function (item) {
          ids.push(item.id)
        })
        this.$confirm(`确定要删除已选择的水库信息 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_RESERVOIR, { id: ids.join(',') }).then(() => {
            this.multipleSelection = []
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
            this.loading = false
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(scenceTypes.SAVE_RESERVOIR, this.form).then(() => {
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.thedata()
            this.loading = false
            this.addbtn = false
            this.form = {}
            this.multipleSelection = []
          }).catch(() => { this.loading = false })
        }
      })
    },
    getCacd () {
      this.$store.dispatch(baseTypes.GET_CACD, { pageIndex: this.cPageIndex, pageSize: this.cPageSize }).then(data => {
        this.cacds = data.results
      }).catch(() => {})
    },
    getDict (type) {
      this.$store.dispatch(baseTypes.GET_DICT, { type: type }).then(data => {
        switch (type) {
          case 'ReservoirType':
            this.rTypes = data
            break
          case 'BarrageType':
            this.barrageTypes = data
            break
          case 'ReleaseType':
            this.releaseTypes = data
            break
          case 'ReservoirScale':
            this.reservoirScales = data
            break
          default:
        }
      }).catch(() => {})
    },
    getMutiRanksAdcd () {
      this.$store.dispatch(scenceTypes.GET_MUTIRANKS_ADCD, {
        parentAdcdCode: this.aDCD
      }).then(data => {
        this.mutiRanksAdcd = data.results
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    this.thedata()
    this.getCacd()
    this.getMutiRanksAdcd()
    this.getDict('ReservoirType')
    this.getDict('BarrageType')
    this.getDict('ReleaseType')
    this.getDict('ReservoirScale')
  },
  mounted () {
    this.$nextTick(() => {
      let sktDiv = document.getElementsByClassName('skt')
      this.height = sktDiv[0].offsetHeight - 120
    })
  }
}
</script>
<style lang="less" src="@/assets/scene.less" scoped>
</style>
<style scoped>
.scence .content{
  padding: 0!important;
}
.scence .skt{
  height: calc(100% - 139px);
}
.scence >>> .el-dialog__body {
  height: 70%;
  left: 0;
  top: 54px;
  bottom: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
.scence >>> .el-dialog__body .el-form-item .el-form-item__content{
  width: 285px !important;
}
.scence >>> .el-dialog__body .el-form-item:nth-of-type(2) .el-form-item__content .el-input {
    width: 90% !important;
}
.scence >>> .el-dialog {
  margin: 0 auto !important;
  /* height: 600px !important; */
}
.scence >>> .el-dialog__body{
  height: 350px !important;
}
.scence >>> .el-form-item{
  width: 46% !important;
  margin-left: 25px;
}
.countryList{
  height: 62px;
  background-color: #ffffff;
  border-radius: 5px;
  color: #444444;
  font-size: 15px;
}
.country{
  float: left;
  font-family: Microsoft YaHei UI;
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  margin-left: 0.5%;
  cursor: pointer;
}
.countryon{
  border-radius: 15px;
  background-color: #fda72c;
  color: #ffffff
}
.country span{
  padding: 4px 15px;
}
.global_map {
  position: absolute;
  right: 30px;
  top: 5px;
}
</style>
